import { Autocomplete, TextField } from '@mui/material'
import React, { SelectHTMLAttributes, useMemo } from 'react'
import { ClassNames, DropdownOption } from "react-day-picker"

const CalenderDropdown = ({ options, disabled, value, onChange, ...rest }: { classNames: ClassNames; options?: DropdownOption[] | undefined; } & Omit<SelectHTMLAttributes<HTMLSelectElement>, "children">) => {
  const selected = useMemo(() => options?.find(opt => opt.value === value) ?? { label: "", value: "" } ,[value, options])
  const label = useMemo(() => rest?.["aria-label"]?.split(" ")?.at(-1), [rest?.["aria-label"]])

  return (
    <Autocomplete
      disableClearable
      value={selected}
      options={options ?? []}
      disabled={!!disabled}
      onChange={(_, value) => {
        onChange?.(({ target: { value: value?.value ?? "" }}) as any)
      }}
      sx={{
        width: label === "Month" ? 120 : 80,
        "& .MuiOutlinedInput-root": {
          paddingRight: "28px",
          "& fieldset": {
            border: "none",
          },
          "&:hover fieldset": {
            border: "none",
          },
          "&.Mui-focused fieldset": {
            border: "none",
          },
        },
        "& .MuiInputBase-input": {
          color: "rgb(var(--primary-color))",
          fontSize: "0.875rem",
          padding: "4px 8px",
        },
        "& .MuiAutocomplete-endAdornment svg": {
          fill: "rgb(var(--primary-color)) !important",
          right: "4px"
        },
      }}
      renderInput={params => <TextField {...params as any} size="small" placeholder={label} variant='outlined' />}
    />
  )
}

export default CalenderDropdown